<app-badge *ngIf="wss.state() as state" [value]="state" [color]="colors[state]"></app-badge>
